import { FC } from 'react';
import {
  Buttons,
  Page,
  TableWrapper,
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';

const Confirmation: FC<ConfirmationProps> = ({ rowData }) => {
  const columnDefs = [
     { minWidth: 220, flex: 1, field: 'moaRawProdNo', headerName: 'Rawprod' },
    { minWidth: 320, flex: 1, field: 'moaRawProdDesc', headerName: 'Description' },
    { minWidth: 220, flex: 1, field: 'specNo', headerName: 'Recipe #' },
    { minWidth: 320, flex: 1, field: 'specDescription', headerName: 'Recipe' },
    { minWidth: 320, flex: 1, field: 'status', headerName: 'Status' },
    {
      minWidth: 320,
      flex: 1,
      field: 'updateDate',
      headerName: 'Date/Time',
      resizable: false,
    },
  ];

  return (
    <Page data-testid='Confirmation'>
      <TableWrapper>
        <Table floatingFiltersHeight={0} returnedRecords={rowData?.length} columnDefs={columnDefs} rowData={rowData} />
      </TableWrapper>
      <Buttons>
        <Export
          columnHeaders={columnDefs.map((col) => {
            return { field: col.field, headerName: col.headerName };
          })}
          rowData={rowData || []}
        />
      </Buttons>
    </Page>
  );
};

export default Confirmation;
